import type { FunctionComponent } from 'react';
import { FamilyTree } from '../../family-tree';
import { useLayout } from '../contexts/layout-context';
import { useYwuApp } from '../contexts/ywu-app-context';
import { useWealthPlanningNavigate } from '../hooks/useWealthPlanningNavigate';

const SCREEN_MARGIN = 'var(--padding-vertical-sm)';
const SCREEN_PADDING_TOP = 'var(--padding-top-sm)';

export const FamilyTreeScreen: FunctionComponent = () => {
    const { totalNavbarHeight } = useLayout();
    const { partnerUuid } = useWealthPlanningNavigate();
    const { isPresentationMode, setPresentationMode } = useYwuApp();

    return (
        <div
            className="family-tree-screen"
            style={{
                width: `calc(100vw - 2 * ${SCREEN_MARGIN})`,
                height: `calc(100vh - ${totalNavbarHeight}px - 2 * ${SCREEN_MARGIN} - ${SCREEN_PADDING_TOP})`,
                margin: SCREEN_MARGIN,
                paddingTop: SCREEN_PADDING_TOP,
            }}
        >
            <FamilyTree partnerUuid={partnerUuid} isPresentationMode={isPresentationMode} setPresentationMode={setPresentationMode} />
        </div>
    );
};
